module.exports = __webpack_public_path__ + "static/media/so-algo-pig2.ec56f429.jpg";